import styled, { css } from 'styled-components'
import { Select } from 'antd'
import {
  P, Div, ButtonForm,
} from 'konsys-ui'
import { theme, media } from '../../styles/_variables'

export const BgContainer = styled.div`
  background-color: ${theme.color.lightPaleGrey};
  padding: 72px 0;
  ${media.tablet`
    padding: 40px 0;
    margin-top: -16px;
  `}
`

export const WidthContainer = styled.div`
  display: ${props => props.flex && 'flex'};
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  width: 100%;
  text-align: ${props => props.textAlign && 'center'};
  max-width: ${theme.maxWidth};
  margin-left: 50%;
  transform: translateX(-50%);
  padding: 0 16px;
`

export const ImgBox = styled.img`
  width: ${props => props.width};
`

export const TableDiv = styled.div`
  display: flex;
  justify-content: ${props => props.center && 'center'};
  align-items: ${props => props.center && 'center'};
  background: ${props => props.background};
  width: 100%;
  height: ${props => props.isHeight && '80px'};
  padding: ${props => props.padding};
  border-bottom: ${props => props.border && theme.color.lightPaleGrey};
  border-top: none;
  > p {
    color: ${props => props.head && theme.color.offWhite};
  }
`

export const HeadWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  /* padding: 0 0 56px; */
  ${media.tablet`
    flex-direction: column;
    align-items: center;
    .imgdiv {
      margin: 0 0 20px;
      text-align: center;
      > img {
        width: 60%;
      }
    }
  `}
`

export const InfoCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-bottom: 1px solid ${theme.color.lightPaleGrey};
  background: ${theme.color.offWhite};
  padding: 0 0 16px;
`

export const EachCell = styled.div`
  display: flex;
  align-items: ${props => (props.center ? 'center' : 'flex-start')};
  flex-direction: column;
  margin: 0 20px;
  width: ${props => (props.width ? props.width : '80px')};
`

export const CellText = styled(P)`
  margin: ${props => props.margin};
  ${props => props.label && css`
    color: ${theme.color.lightGrey};
    font-size: 16px;
  `}
`

export const SearchInputWrapper = styled.div`
  display: flex;
  ${media.tablet`
    margin: 16px 0 0;
  `}
  width: 444px;
  ${media.tablet`
    width: 100%;
    justify-content: flex-start;
  `}
  ${media.mobileM`
    width: 100%;
    flex-direction: column;
    align-items: flex-end;
    > div {
      width: 100%;
      margin: 0;
      &:last-child {
        text-align: right;
        width: auto;
        display: inline-block;
      }
      > button {
        margin: 16px 0 0;
      }
    }
  `}
`

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 60px 0 20px;
  ${media.tablet`
    text-align: left;
    flex-direction: column;
    margin: 0 0 20px;
    align-items: flex-start;
  `}
`

export const SearchTitleWrapper = styled.div`
  > h4 {
    font-size: 30px;
  }
  ${media.tablet`
    width: 444px;
  `}
  ${media.mobileM`
    width: 333px;
  `}
`

export const SearchButton = styled(ButtonForm)`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 6px 16px;
  > span {
    font-size: 22px !important;
  }
  > i {
    font-size: 22px !important;
    margin: 0 8px 0 0 !important;
  }
  ${media.tablet`
    width: 100px;
  `}
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  margin: 10px 0 0;
  ${media.tablet`
    width: 100%;
  `}
`

export const SummaryWrapper = styled.div`
  width: 80%;
  margin: 30px 0 0;
  ${media.tablet`
    width: 100%;
  `}
`

export const ColorDiv = styled.div`
  display: flex;
  justify-content: ${props => props.reverse && 'flex-end'};
  background-color: ${props => (props.primaryColor ? theme.color.primaryColor : theme.color.paleGray)};
  width: ${props => props.width};
  padding: ${props => (props.small ? '6px 40px' : '8px 40px')};
  ${media.tablet`
    padding: 8px 16px;
  `}
`

export const EachInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  margin: ${props => props.margin};
  ${media.mobileM`
    flex-direction: column;
    align-items: flex-start;
  `}
`

export const HeadContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* height: ${props => (props.successHeight ? '210px' : '230px')}; */
  padding: 0 0 8px;
  ${media.tablet`
    height: auto;
  `}
`

export const DateTimeInputContainer = styled.div`
  display: flex;
  flex-basis: 47%;
  flex-direction: row;
  justify-content: space-between;
  ${media.tablet`
    flex-basis: 240px;
  `}
  ${media.mobileXL`
    flex-direction: column;
    align-items: flex-end;
    flex-basis: 160px;
  `}
  ${media.mobileM`
    flex-direction: column;
    align-items: flex-end;
    flex-basis: 100%;
  `}
`

export const DateTimeInputWrapper = styled.div`
  display: flex;
  justify-content: ${props => (props.isStart ? 'flex-start' : 'flex-end')};
  width: ${props => props.width};
  ${media.mobileXL`
    justify-content: flex-end;
  `}
  ${media.mobileM`
    width: 100%;
  `}
`

export const InputColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: ${props => props.margin};
  width: auto;
`

export const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  ${media.tablet`
    margin: 0 -16px;
  `}
`

export const InputContainer = styled.div`
  margin: 60px 0 20px;
  ${media.tablet`
    margin: 60px -16px 20px;
  `}
`

export const InputWrapper = styled.div`
  padding: 24px 40px;
  ${media.tablet`
    padding: 24px 15px;
  `}
`

export const MethodInput = styled(Select)`
  ${media.tablet`
    width: 100%;
  `}
`

export const InputDiv = styled(Div)`
  ${media.tablet`
    flex-basis: 160px;
  `}
  ${media.mobileM`
    width: 100%;
    margin: 10px 0 20px;
    flex-basis: 0;
  `}
`

export const NameInputDiv = styled(InputDiv)`
  ${media.tablet`
    flex-basis: 240px;
  `}
  ${media.mobileXL`
    flex-basis: 160px;
  `}
  ${media.mobileM`
    flex-basis: 0;
  `}
`

export default WidthContainer



// WEBPACK FOOTER //
// ./src/pages/payment-verification-page/styled.js